export const baseURL = "https://backend.luminopt.kz"
